export const translation = {
    'errorFileType': ' je nesprávny typ súboru, povolené sú: ',
    'errorSize': ' je príliš veľký, maximálna povolená veľkosť je: ',
}